import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import api from '~/services/api';
// Importando componente
import Card from '~/components/Card';
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';

import { Container } from './styles';

export default function MotivoEdit({ match }) {
  const history = useHistory();
  const inputRef = useRef(null);
  const [dado, setDado] = useState([]);
  const [carregar, setCarregar] = useState(false);

  useEffect(() => {
    async function getDados() {
      const { id, motivoId } = match.params;
      const response = await api.get(
        `/incorporadora/${id}/cancelamento/${motivoId}`
      );

      setDado(response.data);
    }
    getDados();
  }, [match.params]);

  async function handlerSubmit(data) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});
      const schema = Yup.object().shape({
        name: Yup.string().required('Preencha o campo nome'),
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      await api.put(
        `incorporadora/${match.params.id}/cancelamento/${match.params.motivoId}`,
        {
          name: data.name,
        }
      );

      toast.success('Motivo de cancelamento cadastrado com sucesso');
      history.push(`/incorporadora-edit/${match.params.id}`);
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Motivo de cancelamento já foi cadastrado.');
      }
    } finally {
      setCarregar(false);
    }
  }

  return (
    <Container>
      <h4>Editar Motivo</h4>
      <span>Bem-vindo ao LeadFlow</span>
      <Card>
        <Form
          ref={inputRef}
          initialData={dado}
          onSubmit={handlerSubmit}
          autoComplete="off"
        >
          <Input icon="MdBusiness" label="Nome" name="name" type="text" />
          <Button tamanho="40px" load={carregar}>
            Editar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}

MotivoEdit.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
      motivoId: PropTypes.string,
    }),
  }).isRequired,
};
